import CheckOutlined from "@mui/icons-material/CheckOutlined";
import Copy from "@mui/icons-material/FileCopy";
import {
  Box,
  BoxProps,
  IconButton,
  IconButtonProps,
  SxProps,
  Tooltip,
} from "@mui/material";
import { ReactElement, ReactNode, useEffect, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";

export default function ClickToCopy({
  text,
  children,
  IconButtonProps,
  TextProps,
  iconSx = {},
}: {
  text: string;
  children?: ReactNode;
  IconButtonProps?: IconButtonProps;
  TextProps?: BoxProps;
  iconSx?: SxProps;
}): ReactElement {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      const handle = setTimeout(() => setCopied(false), 3000);
      return () => clearTimeout(handle);
    }
  });

  return (
    <CopyToClipboard text={text} onCopy={() => setCopied(true)}>
      <Box sx={{ display: "flex" }}>
        <Tooltip title={copied ? "Copied" : "Copy to clipboard"}>
          <IconButton {...IconButtonProps}>
            {copied ? <CheckOutlined sx={iconSx} /> : <Copy sx={iconSx} />}
          </IconButton>
        </Tooltip>
        <Box
          {...TextProps}
          sx={{
            flex: 1,
            marginTop: "10px",
            ...TextProps?.sx,
          }}
        >
          {children || text}
        </Box>
      </Box>
    </CopyToClipboard>
  );
}
